import {
  KIOSKS_BY_ACCOUNT_URL,
  SEARCH_KIOSK_URL,
  KIOSKS_URL,
  KIOSK_URL,
  KIOSK_LOCALE_URL,
  KIOSK_LOCALE_UPLOAD_ASSETS_URL,
  KIOSK_PRINT_SIZES_URL,
  GET_PRINT_SIZES_URL,
  KIOSK_BACKGROUND_URL
} from 'app/utils/Constants';

import {
  get,
  post,
  put,
} from 'app/services/ApiService';

export const getKiosks = async accountId => {
  return await get(KIOSKS_BY_ACCOUNT_URL(accountId));
}

export const getKiosksV2 = async params => {
  params.portal2 = true;
  return await post(SEARCH_KIOSK_URL(), params);
}

export const createKiosk = async (params) => {
  return await post(KIOSKS_URL(), params);
}

export const updateKiosk = async (id, params) => {
  params.portal2 = true;
  return await put(KIOSK_URL(id), params);
}

export const getKioskLocales = async (kioskId) => {
  return get(KIOSK_LOCALE_URL(kioskId));
}

export const updateKioskLocale = async (kioskId, localeId, params) => {
  params.portal2 = true;
  return await put(KIOSK_LOCALE_URL(kioskId, localeId), params);
}

export const uploadSignKioskLocaleAsset = async (kioskId, localeId, assetType, contentType) => {
  return await get(KIOSK_LOCALE_UPLOAD_ASSETS_URL(kioskId, localeId, assetType, contentType));
}

export const getKioskPrintSizes = async (kioskId) => {
  return get(KIOSK_PRINT_SIZES_URL(kioskId));
}

export const populatePrintSizes = async (kioskId) => {
  return get(GET_PRINT_SIZES_URL(kioskId));
}

export const toggleEnablePrintSize = async (kioskId, printSizeId, enabled) => {
  return put(KIOSK_PRINT_SIZES_URL(kioskId), {
    kiosk_id: kioskId, print_size_id: printSizeId,
    enable: enabled
  })
}

export const getKioskLocaleBackGround = async (token, locale) => {
  return get(KIOSK_BACKGROUND_URL(token, locale));
}
